import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { InventoryBO } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { InventoryModel } from '@skylab-shared/dataModel';

import { InventoryRepository, InventoryRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface InventoryDialogResult {
    id: number;
    version: string;
}

interface InventoryConfigurationViewModel extends DictionaryDialogViewModelBase<InventoryBO> {
    wasDefault: boolean;
}
@Component({
    selector: 'skl-inventory-dialog',
    templateUrl: './inventory-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, TextValueAccessorDirective, FocusByDirective, FormsModule, ValidateDirective, ButtonComponent, TranslatePipe]
})
export class InventoryDialogComponent extends DictionaryDialogComponentBase
<
InventoryModel,
InventoryBO,
InventoryRepositoryBase,
InventoryConfigurationViewModel
> {
    public constructor(
        @Inject(InventoryRepository) InventoryRepository: InventoryRepositoryBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(EventBus) eventBus: EventBusBase,

        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
    ) {
        super(InventoryRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }
}
